import React from "react";

import RadioButtonSvg from "../../assets/images/icons/Radio/on.svg";

export const RadioOnIcon: React.FC<{ alt?: string }> = ({ alt }) => (
    <img
        src={RadioButtonSvg}
        alt={alt || "Radio"}
    />
);
